import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./Helmet'), 'Helmet'),
  PageImpressions: lazyNamed(() => import('./pages/PageImpressions'), 'PageImpressions'),
  AdImpressions: lazyNamed(() => import('./pages/AdImpressions'), 'AdImpressions'),
};
